(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animation-media-scroll"] && !Shopify.designMode) return;
  try {
    
(function() {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  if (windowWidth < 1024) return;

  const sections = document.querySelectorAll('.mz-media-scroll1');

  sections.forEach(section => {
    const container = section.querySelector('.media-scroll-container');
    const fixed = section.querySelector('.fixed-container');
    const blocks = section.querySelectorAll('.media-block');
    const heading = section.querySelector('.top-heading');
    const topMedia = section.querySelector('.media-top .top-container');
    const topText = section.querySelector('.media-top .top-media-texts');
    const layout = topMedia.getAttribute('data-layout');
    const left = document.querySelector('.mz-header__wrapper>.mz-container .mz-header__logo').getBoundingClientRect().left;
    const mediaWidth = (windowWidth - left * 2) / 2 - 15;

    const phaseAHeight = windowHeight * 2;
    const phaseBHeight = windowHeight * 1.2;
    const phaseCHeight = windowHeight;
    const blocksHeight = blocks.length * windowHeight;

    const totalHeight = phaseAHeight + phaseBHeight + phaseCHeight + blocksHeight;

    container.style.height = totalHeight + 'px';

    // 设置blocks初始样式
    blocks.forEach(block => {
      block.style.left = `${left}px`;
      block.style.width = `calc(100vw - ${left * 2}px)`;
      const media = block.querySelector('.media');
      media.style.width = `${mediaWidth}px`;
      media.style.height = `${mediaWidth * 2 / 3}px`;
      const textBlock = block.querySelector('.text-block');
      textBlock.style.width = `${mediaWidth}px`;
      block.style.opacity = '0';
      block.classList.remove('active');
    });

    // topText位置
    if (layout === 'txt_right') {
      topText.style.right = `${left}px`;
      topText.style.left = 'auto';
    } else {
      topText.style.left = `${left}px`;
      topText.style.right = 'auto';
    }
    topText.style.width = `${mediaWidth}px`;

    window.addEventListener('scroll', () => {
      const containerRect = container.getBoundingClientRect();
      const containerTop = containerRect.top;

      const scrollY = windowHeight - containerTop; 

      // fixed生效条件
      if (containerTop < 50 && scrollY < totalHeight) {
        fixed.classList.add('fixed');
        fixed.style.transform = 'translateY(0)';

        if (scrollY <= phaseAHeight) {
          // 大标题向上滚动，topMedia尺寸不变
          topMedia.style.width = '100vw';
          topMedia.style.height = '100vh';
          topMedia.style.borderRadius = '0';
          topMedia.style.left = '0';
          topMedia.style.right = '0';
          topMedia.style.opacity = '1';

          // heading向上滚动动画
          const percent = scrollY / windowHeight - 1; // 0~1
          console.log(percent);
          heading.style.top = `${100 - percent * 100 - 15}vh`;
          topText.classList.remove('active');

          // blocks隐藏
          blocks.forEach(block => {
            block.style.opacity = '0';
            block.classList.remove('active');
          });

        } else if (scrollY <= phaseAHeight + phaseBHeight) {
          // topMedia开始缩小移动
          const percent = (scrollY - phaseAHeight) / phaseBHeight; // 0~1

          // 宽高缩小比例
          const widthVW = 100 - percent * (100 - (mediaWidth / windowWidth) * 100);
          const heightVH = 100 - percent * (100 - (mediaWidth * 2 / 3 / windowHeight) * 100);

          topMedia.style.width = `${widthVW}vw`;
          topMedia.style.height = `${heightVH}vh`;
          topMedia.style.borderRadius = `${16 * percent}px`;

          if (layout === 'txt_right') {
            topMedia.style.left = `${left * percent}px`;
            topMedia.style.right = 'auto';
          } else {
            topMedia.style.right = `${left * percent}px`;
            topMedia.style.left = 'auto';
          }
          topMedia.style.opacity = '1';
          topText.classList.toggle('active', percent > 0.95);

          // heading完全移除视口顶部
          heading.style.top = `-15vh`;

          // blocks隐藏
          blocks.forEach(block => {
            block.style.opacity = '0';
            block.classList.remove('active');
          });

        } else if (scrollY <= phaseAHeight + phaseBHeight + phaseCHeight) {
          // topMedia固定尺寸，固定位置，显示文字
          topMedia.style.width = `${mediaWidth}px`;
          topMedia.style.height = `${mediaWidth * 2 / 3}px`;
          topMedia.style.borderRadius = '16px';

          if (layout === 'txt_right') {
            topMedia.style.left = `${left}px`;
            topMedia.style.right = 'auto';
          } else {
            topMedia.style.right = `${left}px`;
            topMedia.style.left = 'auto';
          }
          topMedia.style.opacity = '1';
          topText.classList.add('active');

          heading.style.top = `-15vh`;

          // blocks隐藏
          blocks.forEach(block => {
            block.style.opacity = '0';
            block.classList.remove('active');
          });

        } else {
          // 滚动block区域，隐藏topMedia
          const blockScrollY = scrollY - (phaseAHeight + phaseBHeight + phaseCHeight);
          const currentIndex = Math.min(blocks.length - 1, Math.floor(blockScrollY / windowHeight));
          const clampedIndex = Math.min(blocks.length - 1, Math.max(0, currentIndex));

          topMedia.style.opacity = '0';
          topText.classList.remove('active');
          heading.style.top = `-15vh`;

          blocks.forEach((block, idx) => {
            if (idx === clampedIndex) {
              block.style.opacity = '1';
              block.classList.add('active');
            } else {
              block.style.opacity = '0';
              block.classList.remove('active');
            }
          });
        }

      } else {
        // 离开fixed范围
        fixed.classList.remove('fixed');

        if (containerTop > 50) {
          fixed.style.transform = 'translateY(0)';
        } else {
          fixed.style.transform = `translateY(${totalHeight - windowHeight}px)`;
        }

        // 重置状态，防止残留
        // topMedia.style.opacity = '1';
        // topText.classList.remove('active');
        // heading.style.top = '100vh';
        // blocks.forEach(block => {
        //   block.style.opacity = '0';
        //   block.classList.remove('active');
        // });
      }
    });
  });
})();  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animation-media-scroll2"] && !Shopify.designMode) return;
  try {
    
(function() {
  const mediaScrolls = document.querySelectorAll('.mz-media-scroll2');
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;
  let t = 0;
  let p = 0;

  mediaScrolls.forEach(v => {
    const vTop = v.getBoundingClientRect().top;
    const container = v.querySelector('.media-container');
    const scrolled = (windowHeight * 0.7 - v.getBoundingClientRect().top) / (windowHeight * 1.5);
    v.style.height = `${windowHeight * 1.5}px`;
  
    if (vTop <= windowHeight * 0.7 && vTop > (-windowHeight * 1.5)) {
      if (scrolled * 2.5 < 0.5) {
        container.style.opacity = `0.5`;
      } else if (scrolled * 2.5 > 0.9) {
        container.style.opacity = `1`;
      } else {
        container.style.opacity = `${scrolled * 2.2}`;  
      }
    }
  
    if (vTop <= windowHeight * 0.5 && vTop > -10) {
      if (scrolled < 0.3) {
        container.style.transform = `scale(${1 + scrolled * 2.5})`;
        container.classList.remove('fixed');
      } else {
        container.classList.add('fixed');
      }
      v.querySelector('.content-container').classList.remove('scroll-top');
      container.classList.remove('scroll-top');
    } else if (vTop < 50 && vTop > -windowHeight * 0.5) {
      v.querySelector('.content-container').classList.add('scroll-top');
      container.classList.add('scroll-top');
    } else if (vTop <= -windowHeight * 0.5) {
      container.classList.remove('fixed');
    }
    
  });
  
  window.addEventListener('scroll', () => {
    p = document.documentElement.scrollTop;
    if (p > t) {
      // scroll down
    } else {
      // scroll up
    }
    mediaScrolls.forEach(v => {
      const vTop = v.getBoundingClientRect().top;
      const container = v.querySelector('.media-container');
      const scrolled = (windowHeight * 0.7 - v.getBoundingClientRect().top) / (windowHeight * 1.5);
      v.style.height = `${windowHeight * 1.5}px`;

      if (vTop <= windowHeight * 0.7 && vTop > (-windowHeight * 1.5)) {
        if (scrolled * 2.5 < 0.5) {
          container.style.opacity = `0.5`;
        } else if (scrolled * 2.5 > 0.9) {
          container.style.opacity = `1`;
        } else {
          container.style.opacity = `${scrolled * 2.2}`;  
        }
      }

      if (vTop <= windowHeight * 0.5 && vTop > -10) {
        console.log(scrolled);
        if (scrolled < 0.3) {
          container.style.transform = `scale(${1 + scrolled * 2.5})`;
          container.classList.remove('fixed');
          v.querySelector('.content-container').classList.remove('scroll-top');
        } else {
          container.classList.add('fixed');
          v.querySelector('.content-container').classList.add('scroll-top');
        }
        container.classList.remove('scroll-top');
      } else if (vTop < 50 && vTop > -windowHeight * 0.5) {
        container.classList.add('scroll-top');
      } else if (vTop <= -windowHeight * 0.5) {
        container.classList.remove('fixed');
      } else {
        v.querySelector('.content-container').classList.remove('scroll-top');
      }
      
      // if (vTop <= windowHeight * 0.7 && vTop > (-windowHeight * 1.5)) {
      //   if (vTop <= 30) container.classList.add('fixed');
      //   container.style.transform = `translateY(${scrolled * 100 + 10}px) scale(${1.5 * scrolled}) translateZ(0px)`;
      //   if (scrolled > 0.7) {
      //     container.style.opacity = `${scrolled}`;
      //   } else {
      //     container.style.opacity = '0.7';
      //   }
      // } else {
      //   if (v.getBoundingClientRect().top > 30) {
      //     container.style.transform = `translate(0px,0px)`;
      //   }
      //   if (v.getBoundingClientRect().top < (-windowHeight * 1.5)) {
      //     container.style.transform = `translate(0px,${windowHeight * 2}px)`;
      //   }
      //   container.classList.remove('fixed');
      // }
      
    //   if (windowWidth >= 768) {
    //      if (p > t && vTop < windowHeight * 0.4) {
    //       v.querySelector('.media-container').classList.add('scroll-top');
    //       v.querySelector('.content-container').classList.add('scroll-top');
    //     }
    //     if (p < t && vTop > -windowHeight * 0.4) {
    //       v.querySelector('.media-container').classList.remove('scroll-top');
    //       v.querySelector('.content-container').classList.remove('scroll-top');
    //     } 
    //   } else {
    //     if (p > t && vTop < windowHeight * 0.5) {
    //       v.querySelector('.media-container').classList.add('scroll-top');
    //       v.querySelector('.content-container').classList.add('scroll-top');
    //     }
    //     if (p < t && vTop > -windowHeight * 0.1) {
    //       v.querySelector('.media-container').classList.remove('scroll-top');
    //       v.querySelector('.content-container').classList.remove('scroll-top');
    //     }
    //   }
    });
    setTimeout(() => {
      t = p; 
    },0)
  });
})();  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animation-media-scroll3"] && !Shopify.designMode) return;
  try {
    
(function() {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  if (windowWidth < 1024) return;

  var timer = null
  function checkDom(dom, callback) {
    if(dom) {
      callback();
      if(!timer) {
        clearTimeout(timer);
      }
    } else {
      timer = setTimeout(checkDom, 0);
    }
  }
  
  const sections = document.querySelectorAll('.mz-media-scroll1');
  const left = document.querySelector('.mz-header__wrapper>.mz-container .mz-header__logo').getBoundingClientRect().left;
  const mediaWidth = (windowWidth - left * 2) / 2 - 15;
  sections.forEach(v => {
    const container = v.querySelector('.media-scroll-container');
    const fixed = v.querySelector('.fixed-container');
    const blocks = v.querySelectorAll('.media-block');
    const heading = v.querySelector('.top-heading');
    const topMedia = v.querySelector('.media-top .top-container');
    const layout = topMedia.getAttribute('data-layout');
    const topText = v.querySelector('.media-top .top-media-texts');
    let height = windowHeight * (blocks.length + 2);
    if (blocks.length === 0) {
      height = windowHeight * (blocks.length + 3);
    }
    container.style.height = `${height}px`;
    if (layout === 'txt_right') {
      topText.style.right = `${left}px`;
    } else {
      topText.style.left = `${left}px`;
    }

    blocks.forEach(v => {
      v.style.left = `${left}px`;
      v.style.width = `calc(100vw - ${left * 2}px)`;
      v.querySelector('.media').style.width = `${mediaWidth}px`;
      v.querySelector('.media').style.height = `${mediaWidth * 2 / 3}px`;
      v.querySelector('.text-block').style.width = `${mediaWidth}px`;
    });

    let screenCount = blocks.length + 2;
    if (blocks.length !== 0) {
      screenCount = blocks.length + 1;
    }

    window.addEventListener('scroll', () => {
      const vTop = container.getBoundingClientRect().top;
      const scrolled = - vTop / (height - windowHeight);
      let split = 1 / (blocks.length + 2);
      if (blocks.length === 0) {
        split = 1 / (blocks.length + 3);
      }
      if (vTop < 50 && vTop > (-windowHeight -height)) {
        fixed.classList.add('fixed');
        fixed.style.transform = `translate(0px,0px)`;

        // heading show up
        const onePercent = 1 / screenCount;
        if (vTop > (-windowHeight - 100)) {
          topMedia.style.width = '100vw';
          topMedia.style.height = '100vh';
          heading.style.top = `${100 - scrolled / onePercent * 100 - 15}vh`;
          if (layout === 'txt_right') {
            topMedia.style.left = '0';  
          } else {
            topMedia.style.right = '0';
          }
          topMedia.style.borderRadius = '0';
          topText.classList.remove('active');
        }
        // topImage smaller
        if (vTop < -windowHeight && vTop > -windowHeight * 2) {
          const TopImageMedia = v.querySelector('.top-media-texts');
          const scrollPercent = 1 - (scrolled - onePercent) / onePercent;
          const width = 100 - (scrolled - onePercent) / onePercent * 100;
          // TopImageMedia.style.marginRight = `${left - 20}px`;
          TopImageMedia.style.width = `${mediaWidth}px`;
          if ((1 - scrollPercent) * 2 < 0.62) {
            topMedia.style.width = '100vw';
            topMedia.style.height = '100vh';
            if (layout === 'txt_right') {
              topMedia.style.left = '0';  
            } else {
              topMedia.style.right = '0';
            }
            topMedia.style.borderRadius = '0';
            topText.classList.remove('active');
          } else if ((1 - scrollPercent) * 2 < 1) {
            topMedia.style.width = `${width}vw`;
            topMedia.style.height = `${60 * scrollPercent}vw`;
            if (layout === 'txt_right') {
              topMedia.style.left = `${left * (1 - scrollPercent) * 2}px`;
            } else {
              topMedia.style.right = `${left * (1 - scrollPercent) * 2}px`;
            }
            topMedia.style.borderRadius = `${16 * scrollPercent}px`;
          } else if ((1 - scrollPercent) * 2 >= 1) {
            topMedia.style.width = mediaWidth + 'px';
            topMedia.style.height = mediaWidth * 2 / 3 + 'px';
            if (layout === 'txt_right') {
              topMedia.style.left = `${left}px`;
            } else {
              topMedia.style.right = `${left}px`;
            }
            topMedia.style.borderRadius = '16px';
            topText.classList.add('active');
          }
        }

        // image switch
        if (vTop < -windowHeight * 2) {
          topMedia.style.opacity = 0;
          topText.classList.remove('active');
          blocks.forEach(v => {
            v.style.opacity = 0;
            v.classList.remove('active');
          });
          console.log(vTop, -windowHeight * 2, height);
          if (vTop > (windowHeight / 2 - height)) {
            blocks[Math.floor(scrolled / split) - 3].style.opacity = 1;
            blocks[Math.floor(scrolled / split) - 3].classList.add('active');    
          }
        } else {
          blocks.forEach(v => {
            v.style.opacity = 0;
            v.classList.remove('active');
          });
          topMedia.style.opacity = 1;
        }

        if (vTop <= (windowHeight - height)) {
          fixed.classList.remove('fixed');
          fixed.style.transform = `translate(0px,${windowHeight * (blocks.length + 1)}px)`;
          topMedia.style.opacity = 0;
        }
        
      } else {
        fixed.classList.remove('fixed');
        if (vTop > 50) {
          fixed.style.transform = `translate(0px,0px)`;
        }
        if (vTop <= (windowHeight -height)) {
          if (blocks.length === 0) {
            fixed.style.transform = `translate(0px,${windowHeight * (blocks.length + 2)}px)`;
          } else {
            fixed.style.transform = `translate(0px,${windowHeight * (blocks.length + 1)}px)`;
          }
        }
      }
    });
  });
})();  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animation-vertical-switch"] && !Shopify.designMode) return;
  try {
    
(function() {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  var timer = null
  function checkDom(dom, callback) {
    if(dom) {
      callback();
      if(!timer) {
        clearTimeout(timer);
      }
    } else {
      timer = setTimeout(checkDom, 0);
    }
  }
  
  const sections = document.querySelectorAll('.mz-vertical-switch');
  sections.forEach(v => {
    const container = v.querySelector('.animation-container');
    const fixed = v.querySelector('.fixed-container');
    const blocks = v.querySelectorAll('.media-block');
    const height = windowHeight * 2;
    container.style.height = `${height}px`;

    window.addEventListener('scroll', () => {
      const vTop = container.getBoundingClientRect().top;
      const scrolled = 100 + vTop / windowHeight * 100;
      if (vTop <= 0) {
        fixed.classList.add('fixed');
        fixed.style.transform = `translate(0px,0px)`;

        blocks[0].style.height = scrolled + 'vh';

        if (vTop <= -windowHeight) {
          fixed.classList.remove('fixed');
          fixed.style.transform = `translate(0px,${windowHeight}px)`; 
        }
      } else {
        fixed.classList.remove('fixed');
        fixed.style.transform = `translate(0px,0px)`;
      }
    });
  });
})();  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertical-slideshow"] && !Shopify.designMode) return;
  try {
    
(function() {
  // 防抖函数，避免滚动和resize事件过于频繁触发
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  function initVerticalSlideshow() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 1024) return; // 小屏幕不启用
    
    const slideshows = document.querySelectorAll('.mz-vertical-slideshow');
    if (!slideshows.length) return;

    slideshows.forEach(slideshow => {
      const upperContainer = slideshow.querySelector('.mz-upper-container');
      const container = slideshow.querySelector('.vertical-slideshow');
      if (!container) return;

      const images = slideshow.querySelectorAll('.slide-image-pc');
      const medias = slideshow.querySelectorAll('.media-container');
      const progress = slideshow.querySelector('.progress-bar');
      const progressActive = progress ? progress.querySelector('.active-line') : null;
      const progressBlocks = slideshow.querySelectorAll('.pagination-block');

      if (!images.length || !medias.length || !progress || !progressActive || !progressBlocks.length) return;

      const originalContainerWidth = upperContainer.getBoundingClientRect().width;
      
      // 数据
      const windowHeight = window.innerHeight;
      const imageHeightVW = parseFloat(container.getAttribute('data-height'));

      const imageWidthNew = slideshow.querySelector('.slide-image-pc').getBoundingClientRect().width;
      console.log(imageWidthNew);
      
      // 计算容器高度
      const containerHeight = windowHeight * images.length - (1 - imageHeightVW / 100) * windowHeight + 220;
      slideshow.querySelector('.mz-section-inner').style.height = `${containerHeight + 30}px`;

      // 进度条宽度及位置
      const left = document.querySelector('.mz-header__wrapper>.mz-container .mz-header__logo')?.getBoundingClientRect().left || 0;
      const imageWidth = (1 - imageHeightVW / 100) * windowWidth;
      // progress.style.left = `0%`;
      progress.style.width = `${windowWidth - imageWidthNew - left * 2 - 50}px`;
      let progressHeight = 0;

      function updateSlideshowState() {
        const rect = slideshow.getBoundingClientRect();
        const maxTranslateY = containerHeight - container.offsetHeight - 100;

        container.style.width = `${originalContainerWidth}px`;
        
        // 滚动进度，限制0~1范围
        const scrolled = Math.min(Math.max(-rect.top / (containerHeight - windowHeight), 0), 1);
        const split = 1 / progressBlocks.length;
        const activeIndex = Math.min(Math.floor(scrolled / split), progressBlocks.length - 1);

        if (rect.top < 50 && rect.top > (windowHeight - containerHeight)) {
          slideshow.classList.add('fixed');
          container.style.transform = 'translate(0, 0)';
          progressHeight = progress.offsetHeight;
          progressActive.style.height = `${progressHeight * scrolled}px`;

          // 激活标题
          progressBlocks.forEach((title, i) => title.classList.toggle('active', i === activeIndex));

          // 激活媒体及动画
          medias.forEach((media, i) => {
            const content = media.querySelector('.slide-content');
            if (i === activeIndex) {
              media.style.opacity = 1;
              media.classList.add('active');
              if (content) content.style.opacity = 1;

              const localProgress = (scrolled - activeIndex * split) / split;

              if (localProgress < 0.5) {
                const translateY = -localProgress * 50;
                if (content) content.style.transform = `translate(0, ${translateY}%)`;

                const mediaImage = media.querySelector('.image-pc');
                const mediaVideo = media.querySelector('video');
                const translateMediaValue = translateY + 10;

                // if (mediaImage) mediaImage.style.transform = `translate3D(0, ${translateMediaValue}px, 0)`;
                // if (mediaVideo) mediaVideo.style.transform = `translate3D(0, ${translateMediaValue}px, 0)`;
              } else {
                // if (content) content.style.transform = 'translate(0, 0)';
                // if (media.querySelector('.image-pc')) media.querySelector('.image-pc').style.transform = 'translate3D(0, 0px, 0)';
                // if (media.querySelector('video')) media.querySelector('video').style.transform = 'translate3D(0, 0px, 0)';
              }
            } else {
              media.style.opacity = 0;
              media.classList.remove('active');
              if (content) {
                content.style.opacity = 0;
              }
              const mediaImage = media.querySelector('.image-pc');
              const mediaVideo = media.querySelector('video');
              // if (mediaImage) mediaImage.style.transform = 'translate3D(0, 0, 0)';
              // if (mediaVideo) mediaVideo.style.transform = 'translate3D(0, 0, 0)';
            }
          });
        } else {
          slideshow.classList.remove('fixed');

          if (rect.top > 50) {
            container.style.transform = 'translate(0, 0)';
            progressActive.style.height = '0px';
          } else if (rect.top < (windowHeight - containerHeight)) {
            container.style.transform = `translate(0, ${maxTranslateY}px)`;
            progressActive.style.height = `${progressHeight + 20}px`;
          }
        }
      }

      const handleScroll = debounce(updateSlideshowState, 16);
      window.addEventListener('scroll', handleScroll);

      const handleResize = debounce(() => {
        // 重新计算窗口和容器尺寸相关变量
        const newWindowWidth = window.innerWidth;
        if (newWindowWidth < 1024) {
          slideshow.classList.remove('fixed');
          container.style.transform = '';
          progressActive.style.height = '0px';
          return;
        }
        // 更新宽度
        const newImageWidth = (1 - imageHeightVW / 100) * newWindowWidth;
        progress.style.width = `${newWindowWidth - newImageWidth - left}px`;

        // 更新容器高度
        const newWindowHeight = window.innerHeight;
        const newContainerHeight = newWindowHeight * images.length - (1 - imageHeightVW / 100) * newWindowHeight + 220;
        slideshow.querySelector('.mz-section-inner').style.height = `${newContainerHeight + 30}px`;
        
        updateSlideshowState();
      }, 200);

      window.addEventListener('resize', handleResize);

      // 初始化状态
      updateSlideshowState();
    });
  }

  if (document.readyState !== 'loading') {
    initVerticalSlideshow();
  } else {
    document.addEventListener('DOMContentLoaded', initVerticalSlideshow);
  }
})();


  } catch(e) { console.error(e); }
})();
})();
